import React from "react";
import { TrendingUp, Coins, Crosshair, Eye } from "lucide-react";

const choices = [
  {
    icon: TrendingUp,
    title: "Scalability",
    body:
      "On-demand processing, code-first pipelines and indexed parquet. The system can grow horizontally as more operators and verticals come online.",
  },
  {
    icon: Coins,
    title: "Cost efficiency",
    body:
      "Compute on compressed, indexed data. Filter before processing. 80–90% less processing cost than the previous generation of platforms.",
  },
  {
    icon: Crosshair,
    title: "Precision",
    body:
      "15-minute temporal resolution, 250m spatial granularity. Honest about the limits of network-derived position data.",
  },
  {
    icon: Eye,
    title: "Transparency",
    body:
      "Open methodology, documented assumptions, quality metrics on every aggregate. Customers can audit how a number was made.",
  },
];

const CleanSheetSection = () => {
  return (
    <section id="clean-sheet" className="py-24 bg-paper-200">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-3xl mb-12">
          <p className="text-xs font-semibold tracking-widest text-brand-600 uppercase mb-3">
            A clean-sheet platform
          </p>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-ink tracking-tight mb-4">
            Built by people who've done this before.
          </h2>
          <p className="text-lg text-ink-muted leading-relaxed">
            Between them, our founders have spent 21 years building and
            delivering mobility data products inside telecom operators. That
            experience spans network data, privacy, analytics,
            product development and commercial delivery. We used those lessons
            to build Telcofy in 2025 with code-first pipelines, on-demand
            processing and documented methods.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {choices.map(({ icon: Icon, title, body }) => (
            <div
              key={title}
              className="bg-paper border border-paper-300 rounded-lg p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-brand-card hover:border-brand-500/40"
            >
              <div className="flex items-center gap-2.5 mb-3">
                <Icon size={18} className="text-brand-600" />
                <h3 className="font-display text-base font-semibold text-ink">
                  {title}
                </h3>
              </div>
              <p className="text-sm text-ink-muted leading-relaxed">
                {body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CleanSheetSection;
